/**
 * Injects head partial content into the document head
 * This should be called early, ideally via inline script in the head
 */
export async function initHead() {
  const htmlEl = document.documentElement;
  const pageTitle = htmlEl.getAttribute("data-page-title");
  
  if (!pageTitle) {
    console.warn("data-page-title attribute not found on <html> tag");
    return;
  }

  try {
    const response = await fetch("./partials/head.html");
    if (!response.ok) throw new Error("Failed to load head partial");
    
    const html = await response.text();
    
    // Create a temporary container to parse the HTML
    const temp = document.createElement("div");
    temp.innerHTML = html.trim();
    
    // Get all elements from the partial
    const elements = Array.from(temp.children);
    
    // Inject each element into the head (avoid duplicates)
    const head = document.head;
    elements.forEach((el) => {
      // Check if element already exists to avoid duplicates
      const tagName = el.tagName.toLowerCase();
      const selector = tagName === "meta" 
        ? `${tagName}[charset="${el.getAttribute("charset")}"], ${tagName}[name="${el.getAttribute("name")}"]`
        : tagName === "link"
        ? `${tagName}[rel="${el.getAttribute("rel")}"][href="${el.getAttribute("href")}"]`
        : null;
      
      if (selector && head.querySelector(selector)) {
        return; // Skip if already exists
      }
      
      // Clone and append
      const cloned = el.cloneNode(true);
      head.appendChild(cloned);
    });
    
    // Update the title
    let titleEl = head.querySelector("title");
    if (!titleEl) {
      titleEl = document.createElement("title");
      head.insertBefore(titleEl, head.firstChild);
    }
    titleEl.textContent = pageTitle;
    
  } catch (err) {
    console.error("Error loading head partial:", err);
  }
}

export async function initPartials() {
  const headerHost = document.querySelector("[data-header]");
  const footerHost = document.querySelector("[data-footer]");
  const carouselHost = document.querySelector("[data-carousel]");
  const ctaHost = document.querySelector("[data-cta]");
  const iconsGridHost = document.querySelector("[data-icons-grid]");

  const tasks = [];

  // Header
  if (headerHost) {
    tasks.push(
      fetch("./partials/header.html")
        .then((res) => {
          if (!res.ok) throw new Error("Failed to load header partial");
          return res.text();
        })
        .then((html) => {
          headerHost.innerHTML = html;
        })
        .catch((err) => {
          console.error(err);
        })
    );
  }

  // Footer
  if (footerHost) {
    tasks.push(
      fetch("./partials/footer.html")
        .then((res) => {
          if (!res.ok) throw new Error("Failed to load footer partial");
          return res.text();
        })
        .then((html) => {
          footerHost.innerHTML = html;

          const yearEl = footerHost.querySelector("[data-year]");
          if (yearEl) {
            yearEl.textContent = String(new Date().getFullYear());
          }
        })
        .catch((err) => {
          console.error(err);
        })
    );
  }
  // Carousel
  if (carouselHost) {
    tasks.push(
      fetch("./partials/carousel.html")
        .then((res) => {
          if (!res.ok) throw new Error("Failed to load carousel partial");
          return res.text();
        })
        .then((html) => {
          carouselHost.innerHTML = html;
        })
        .catch((err) => {
          console.error(err);
        })
    );
  }
  // CTA
  if (ctaHost) {
    tasks.push(
      fetch("./partials/cta.html")
        .then((res) => {
          if (!res.ok) throw new Error("Failed to load CTA partial");
          return res.text();
        })
        .then((html) => {
          ctaHost.innerHTML = html;
        })
        .catch((err) => {
          console.error(err);
        })
    );
  }

  // Icons grid
  if (iconsGridHost) {
    tasks.push(
      fetch("./partials/icons-grid.html")
        .then((res) => {
          if (!res.ok) throw new Error("Failed to load icons grid partial");
          return res.text();
        })
        .then((html) => {
          iconsGridHost.innerHTML = html;
        })
        .catch((err) => {
          console.error(err);
        })
    );
  }

  // Ensure we always return a Promise, even if there are no hosts
  return Promise.all(tasks);
}


